<template>
  <div>
    <Form :label-width="150">
      <!-- 基本信息 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.basicinformationmanageddatabase' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.cloudPlatform' )">
                  <span style="width: 200px;">{{accountTypeSearchKey}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.account' )">
                  <span style="width: 200px;">{{accountId}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.area' )">
                  <span style="width: 200px;">{{region}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.uses' )">
                  <span style="width: 200px;">{{use}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.periodofuse' )">
                  <span style="width: 200px;">{{periodOfUse}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceType' )">
                  <span style="width: 200px;">{{resourceType}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.environment' )">
                  <span style="width: 200px;">{{environment}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.flow' )">
                  <span style="width: 200px;">{{approvalFlow}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceGroup' )">
                  <span style="width: 200px;">{{resourceGroup}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- 资源配置 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.resourceConfiguration' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.databaseType' )">
                  <span style="width: 200px;">{{resourceType}}</span>
                </FormItem>
              </Col>
            </Row>

            <!-- 当数据库类型为"Azure MySQL 服务器"时 显示 -->
            <div v-if="databaseType==5||databaseType==6">
              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.serverName' )">
                    <span style="width: 200px;">{{name}}</span>
                  </FormItem>
                </Col>
              </Row>

              <div v-if="databaseType==5">
                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.version' )">
                      <span style="width: 200px;">{{mySqulVersion}}</span>
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <div v-if="databaseType==6">
                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.version' )">
                      <span style="width: 200px;">{{mariaDBVersion}}</span>
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.serverType' )">
                    <span style="width: 200px;">{{serverType}}</span>
                  </FormItem>
                </Col>
              </Row>

              <!-- 服务器类型为"基本" -->
              <div v-if="serverType=='Basic'">
                <Row>
                  <Col span="11">
                    <FormItem label="vCore:">
                      <span style="width: 200px;">{{skuCapacity}}</span>
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.storage' )">
                      <span style="width: 200px;">{{storage}}GB</span>
                    </FormItem>
                  </Col>
                </Row>

                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.storageAutomatedGrowth' )">
                      <span style="width: 200px;">{{storageAutoGrow}}</span>
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.backuphold' )">
                      <span style="width: 200px;">{{backupRetentionDays}}</span>
                    </FormItem>
                  </Col>
                </Row>

                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.backupredundancy' )">
                      <span style="width: 200px;">{{basicGeoRedundantBackup}}</span>
                    </FormItem>
                  </Col>
                </Row>
              </div>
              <!-- 服务器类型为"常规用途" -->
              <div v-if="serverType=='GeneralPurpose'">
                <Row>
                  <Col span="11">
                    <FormItem label="vCore:">
                      <span style="width: 200px;">{{skuCapacity}}</span>
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.storage' )">
                      <span style="width: 200px;">{{storage}}GB</span>
                    </FormItem>
                  </Col>
                </Row>

                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.storageAutomatedGrowth' )">
                      <span style="width: 200px;">{{storageAutoGrow}}</span>
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.backuphold' )">
                      <span style="width: 200px;">{{backupRetentionDays}}</span>
                    </FormItem>
                  </Col>
                </Row>
                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.backupredundancy' )">
                      <span style="width: 200px;">{{geoRedundantBackup}}</span>
                    </FormItem>
                  </Col>
                </Row>
              </div>
              <!-- 服务器类型为"内存优化" -->
              <div v-if="serverType=='MemoryOptimized'">
                <Row>
                  <Col span="11">
                    <FormItem label="vCore:">
                      <span style="width: 200px;">{{skuCapacity}}</span>
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.storage' )">
                      <span style="width: 200px;">{{storage}}GB</span>
                    </FormItem>
                  </Col>
                </Row>

                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.storageAutomatedGrowth' )">
                      <span style="width: 200px;">{{storageAutoGrow}}</span>
                    </FormItem>
                  </Col>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.backuphold' )">
                      <span style="width: 200px;">{{backupRetentionDays}}</span>
                    </FormItem>
                  </Col>
                </Row>
                <Row>
                  <Col span="11">
                    <FormItem :label="$t( 'resourceLifecycle.backupredundancy' )">
                      <span style="width: 200px;">{{geoRedundantBackup}}</span>
                    </FormItem>
                  </Col>
                </Row>
              </div>

              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.username' )">
                    <span style="width: 200px;">{{userName}}</span>
                  </FormItem>
                </Col>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.password' )">
                    <span style="width: 200px;">******</span>
                  </FormItem>
                </Col>
              </Row>
            </div>


            <!-- 当数据库类型为"Azure Redis 服务器"时 显示 -->
            <div v-if="databaseType==7">
              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.dNSName' )">
                    <span style="width: 200px;">{{dnsName}}</span>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.pricingTier' )">
                    <span style="width: 200px;">{{pricingLayer}}</span>
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col span="11">
                  <FormItem :label="$t( 'resourceLifecycle.whethertoenablenonencryptedSSL' )">
                    <span style="width: 200px;">{{enableNonSslPort}}</span>
                  </FormItem>
                </Col>
              </Row>
            </div>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.exhibits' )" prop="enclosure">
                  <Table :no-data-text="$t('common.noData')" border :columns="columnsFile" :data="fileData" :border="false">
                    <template slot-scope="{row,index}" slot="download">
                      <!-- 下载 -->
                      <Button type="success" :loading="modal_loadings" size="small" @click="downloadFile(row)">{{$t('resourceLifecycle.download')}}
                      </Button>
                    </template>
                  </Table>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.remarkation' )">
                  <span style="width: 200px;">{{describe}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>


      <!-- 预估费用 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.estimatedcosts' )}}</p>
            <Row>
              <Col span="12">
                <FormItem :label="$t( 'resourceLifecycle.estimatedcost' )">
                  <i style="font-size: 20px;">￥ {{cost}}</i>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
  export default {
    name: 'AmazonVirtualMachineDetail',
    props: ['azureResourceApplicationBasicInfoForm'],
    components: {},
    data() {
      return {
        cost: 0,
        modal_loadings: false,//下载
        resourceGroup: '',
        accountTypeSearchKey: '',
        accountId: '',
        region: '',
        use: '',
        periodOfUse: '',
        resourceType: '',
        environment: '',
        approvalFlow: '',
        name: '',
        mySqulVersion: '',
        databaseType: 7,
        serverType: 'Basic',
        userName: '',
        password: '',
        dnsName: '',
        pricingLayer: '',
        enableNonSslPort: '',
        skuCapacity: '',
        storage: '',
        backupRetentionDays: '',
        storageAutoGrow: '',
        mariaDBVersion: '',
        geoRedundantBackup: '',
        basicGeoRedundantBackup: '',
        describe: '',
        columnsFile: [
          {
            title: this.$t( 'resourceLifecycle.filenames' ),
            key: 'fileName'
          },
          {
            title: this.$t( 'resourceLifecycle.fileType' ),
            key: 'fileType'
          },
          {
            title: this.$t('common.operation'),
            slot: 'download',
            "width": 100
          }],
        fileData: []
      }
    },
    mounted: function () {
      this.dealWithLine();
    },
    methods: {
      // 处理
      /****************************************************/
      dealWithLine: function () {
        // 审批
        this.$api.lifecycleResourceApplication.queryLifecycleResourceById({
          "id": this.azureResourceApplicationBasicInfoForm.id
        })
          .then(res => {
            // Common Params
            this.accountTypeSearchKey = res.data.platformString;
            this.accountId = res.data.accountName;
            this.region = res.data.region;
            this.use = res.data.usageNote;
            this.periodOfUse = res.data.duration + this.$t( 'resourceLifecycle.months' );
            this.resourceType = res.data.lifecycleResourceTypeDesc;
            this.environment = res.data.environmentDesc;
            this.approvalFlow = res.data.approvalFlow;
            this.describe = res.data.remark;
            this.cost = res.data.cost;
            if (res.data.attachmentList != null && res.data.attachmentList != undefined && res.data.attachmentList.length > 0) {
              this.fileData = res.data.attachmentList;
            }

            this.databaseType = res.data.lifecycleResourceType;

            if (this.databaseType == 5) {
              this.resourceGroup = res.data.lifecycleResourceAzureMySQLDTO.resourceGroup;
              this.name = res.data.lifecycleResourceAzureMySQLDTO.dbName;
              this.mySqulVersion = res.data.lifecycleResourceAzureMySQLDTO.serverVersion;
              this.serverType = res.data.lifecycleResourceAzureMySQLDTO.skuTier;
              this.skuCapacity = res.data.lifecycleResourceAzureMySQLDTO.skuCapacity;
              this.storage = res.data.lifecycleResourceAzureMySQLDTO.storage;
              this.storageAutoGrow = res.data.lifecycleResourceAzureMySQLDTO.storageAutoGrow == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              this.backupRetentionDays = res.data.lifecycleResourceAzureMySQLDTO.backupRetentionDays + this.$t( 'configuration_management.schedules.day' );
              if (this.serverType == "Basic") {
                this.basicGeoRedundantBackup = res.data.lifecycleResourceAzureMySQLDTO.geoRedundantBackup == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              } else if (this.serverType == "GeneralPurpose") {
                this.geoRedundantBackup = res.data.lifecycleResourceAzureMySQLDTO.geoRedundantBackup == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              } else if (this.serverType == "MemoryOptimized") {
                this.geoRedundantBackup = res.data.lifecycleResourceAzureMySQLDTO.geoRedundantBackup == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              }
              this.userName = res.data.lifecycleResourceAzureMySQLDTO.administratorLogin;
              this.password = res.data.lifecycleResourceAzureMySQLDTO.administratorLoginPassword;
            } else if (this.databaseType == 6) {
              this.resourceGroup = res.data.lifecycleResourceAzureMariaDBDTO.resourceGroup;
              this.name = res.data.lifecycleResourceAzureMariaDBDTO.dbName;
              this.mariaDBVersion = res.data.lifecycleResourceAzureMariaDBDTO.serverVersion;
              this.serverType = res.data.lifecycleResourceAzureMariaDBDTO.skuTier;
              this.skuCapacity = res.data.lifecycleResourceAzureMariaDBDTO.skuCapacity;
              this.storage = res.data.lifecycleResourceAzureMariaDBDTO.storage;
              this.storageAutoGrow = res.data.lifecycleResourceAzureMariaDBDTO.storageAutoGrow == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              this.backupRetentionDays = res.data.lifecycleResourceAzureMariaDBDTO.backupRetentionDays + this.$t( 'configuration_management.schedules.day' );
              if (this.serverType == "Basic") {
                this.basicGeoRedundantBackup = res.data.lifecycleResourceAzureMariaDBDTO.geoRedundantBackup == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              } else if (this.serverType == "GeneralPurpose") {
                this.geoRedundantBackup = res.data.lifecycleResourceAzureMariaDBDTO.geoRedundantBackup == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              } else if (this.serverType == "MemoryOptimized") {
                this.geoRedundantBackup = res.data.lifecycleResourceAzureMariaDBDTO.geoRedundantBackup == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
              }
              this.userName = res.data.lifecycleResourceAzureMariaDBDTO.administratorLogin;
              this.password = res.data.lifecycleResourceAzureMariaDBDTO.administratorLoginPassword;
            } else {
              this.resourceGroup = res.data.lifecycleResourceAzureRedisDTO.resourceGroup;
              this.dnsName = res.data.lifecycleResourceAzureRedisDTO.redisName;
              this.pricingLayer = res.data.lifecycleResourceAzureRedisDTO.pricingTier;
              this.enableNonSslPort = res.data.lifecycleResourceAzureRedisDTO.enableNonSslPort == 0 ? this.$t( 'resourceLifecycle.enabling' ) : this.$t( 'resourceLifecycle.disabling' );
            }
          })
      },
      // 下载附件
      /************************************************************/
      downloadFile: function (row) {
        // 下载附件
        this.modal_loadings = true;
        this.$api.file.downloadFile("id", row.id)
          .then(res => {
            let aTag = document.createElement('a');
            let blob = new Blob([res.data], {type: 'text/plain;charset=UTF-8'})
            aTag.download = row.fileName;
            aTag.href = URL.createObjectURL(blob);
            aTag.click();
            URL.revokeObjectURL(blob);
            setTimeout(() => {
              this.modal_loadings = false;
              this.$Message.success(this.$t( 'resourceLifecycle.response.downloadSuccess'));
            }, 1000);
          })
      }
    }
  }
</script>

<style scoped>
  .ivu-form-item {
    margin-bottom: 0px !important;
    vertical-align: top;
    zoom: 1;
  }
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/managed_database/AzureManagedDatabaseDetail.vue